<template style="background: none">
    <div>
        <filter-container
            style="background: #fff;padding: 20px;border-radius: 14px;margin-bottom: 20px;"
            :filterData="filterData"
            :filterDataSelected="filterDataSelected"
            :isPreloader="isPreloader"
            @onChangeFilter="onChangeFilter"
        />
        <div class="content">

            <div v-if="!isPreloader && selectedDetailSummary === ''" class="budget">

                <div
                        v-for="(boxValue, index) of tableSummary"
                        :key="index"
                        class="budget__item"
                >
                    <div class="budget__item-title">{{boxValue.title}}</div>
                    <div class="budget__count">{{boxValue.current_value.toLocaleString('ru-RU')}} ₽</div>
                    <div class="budget-dynamic">
                        <div class="budget-dynamic__title">Динамика изменения</div>
                        <div
                                v-for="(dynamicsValue, dynamicsIndex) of boxValue.dynamics"
                                :key="dynamicsIndex"
                                class="budget-dynamic__item"
                        >
                            <div
                                    class="budget-dynamic__arrow"
                                    :class="{
                                        'budget-dynamic__arrow_max' : dynamicsValue.diff > 0,
                                        'budget-dynamic__arrow_min' : dynamicsValue.diff < 0
                                    }"
                            >
                                <i v-if="dynamicsValue.diff > 0" class="fa fa-arrow-up"></i>
                                <i v-if="dynamicsValue.diff < 0" class="fa fa-arrow-down"></i>
                            </div>
                            <div class="budget-dynamic__date">{{dynamicsValue.name}} <span>/</span> {{dynamicsValue.value.toLocaleString('ru-RU')}} ₽</div>
                            <div class="budget-dynamic__count">{{dynamicsValue.diff > 0 ? ('+ ' + dynamicsValue.diff.toLocaleString('ru-RU')) : dynamicsValue.diff.toLocaleString('ru-RU')}} ₽</div>
                        </div>
                    </div>
                    <button v-if="false" class="simple-link" @click="showDetail(boxValue.attribute)">Динамика по месяцам</button>
                </div>

            </div>
            <div
                    style="margin-top: 10px;padding: 20px 25px;background: #fff;border-radius: 14px;flex: 1;"
                    v-if="!isPreloader && selectedDetailSummary !== ''"
            >
                <div class="view-analytics-budget__table-title">
                    {{tableNames[selectedDetailSummary]}}
                </div>
                <button
                        class="btn_default"
                        @click="clearSelected()"
                        style="margin-bottom: 20px"
                >Назад</button>
                <table-base
                        :columns="Object.keys(detailTables).length !== 0 ? detailTables[selectedDetailSummary].columns : {}"
                        :rows="Object.keys(detailTables).length !== 0 ? detailTables[selectedDetailSummary].rows : []"
                        :isPreloader="isPreloader"
                        :isSort="true"
                        :columnsSort="columnsSort[selectedDetailSummary]"
                        :isObjectCell="true"
                />
            </div>

        </div>
        <div class="view-analytics__table-container">
            <div class="view-analytics__table-title">
                Текущий бюджет
            </div>
            <table-base-v2
                :isPreloader="isTableDates"
                :columns="tableDates.labels || new Map()"
                :rows="tableDates.rows || []"
                :columnsStyles="columnsStylesDates"
                :isSort="true"
                :columnsSort="columnsSortDates"
                :columnsChartBar="columnsChartBarDates"
            />
        </div>
    </div>
</template>

<script>
import FilterContainer from '../../components/Filter/FilterContainer';
import TableBaseV2 from '../../components/Tables/TableBaseV2';
import TableBase from '../../components/Tables/TableBase';
import mixinAnalytics from '../../mixins/mixinAnalytics';
import serviceApi from '../../services/serviceApi';
import schemeApi from '../../schemes/schemeApi';

let {
    routeAnalyticsTotalBudget,
    routeAnalyticsSummary,
    routeAnalyticsSummaryDetail
} = schemeApi;
export default {
    name: 'ViewAnalyticsSummary',
    components: {
        FilterContainer,
        TableBaseV2,
        TableBase
    },
    mixins: [
        mixinAnalytics
    ],
    /**
     * Данные компонента
     * @property {Object} tableDates - таблица текущего бюджета
     * @property {boolean} isTableDates - условие показа прелоадера для таблицы текущего бюджета
     * @property {boolean} isPreloader - условие показа прелоадера
     * @property {array} tableSummary - сводная таблица
     * @property {object} detailTables - детализированные сводные таблицы
     * @property {string} selectedDetailSummary - название атрибута выбранного для детализации
     * @property {object} tableNames - названия таблиц
     */
    data: () => ({
        tableDates: {},
        isTableDates: false,
        isPreloader: false,
        tableSummary: [],
        detailTables: {},
        selectedDetailSummary: '',
        tableNames: {
            earn: "Выручка за год по месяцам",
            consumption: "Себестоимость за год по месяцам",
            profit: "Прибыль за год по месяцам",
            tax: "Налог за год по месяцам",
            profit_without_tax: "Прибыль без налога за год по месяцам"
        },
    }),
    computed: {
        /**
         * тело запроса
         * @returns {object}
         */
        reqBodyGetDataClients() {
            let reqBody = {
                filter_params: this.filterDataSelected
            }
            return reqBody;
        },
        /**
         * колонки с гистограммой для таблицы текущий бюджет
         * @returns {Object}
         */
        columnsChartBarDates() {
            let columnsChartBarDates = {};
            let {labels = new Map(), rows = []} = this.tableDates;
            labels.forEach((_, key) => {
                switch(key) {
                    case '0-totalValue':
                        columnsChartBarDates[key] = {
                            totalValue: Math.max(...rows.map(row => row[key])),
                            fillKeys: ['0-totalValue']
                        };
                        break;
                    default:
                        break;
                }
            });
            return columnsChartBarDates;
        },
        /**
         * стили для колонок таблицы текущий бюджет
         * @returns {Object}
         */
        columnsStylesDates() {
            let columnsStylesDates = {};
            let {labels = new Map()} = this.tableDates;
            labels.forEach((_, key) => {
                switch(key) {
                    case '0-totalValue':
                        columnsStylesDates[key] = {
                            'color': '#000', 
                            'border-right': '3px solid #f5f7f9',
                            'width': '100px'
                        };
                        break;
                    case '0-total':
                        columnsStylesDates[key] = {'color': '#000'};
                        break;
                    default:
                        columnsStylesDates[key] = {
                            'text-align': 'right',
                            'width': '100px'
                        };
                        break;
                }
            });
            return columnsStylesDates;
        },
        /**
         * колонки для сортировки для таблицы текущий бюджет
         * @returns {Object}
         */
        columnsSortDates() {
            let columnsSortDates = {};
            if (typeof this.tableDates.labels !== 'undefined') {
                this.tableDates.labels.forEach((_, key) => {
                    if (key === '0-total')
                        columnsSortDates[key] = {typeColumn: 'String'};
                    else
                        columnsSortDates[key] = {typeColumn: 'Number'};
                });
            }
            return columnsSortDates;
        },
        /**
         * колонки по которым можно сортировать
         * @returns {object}
         */
        columnsSort() {
            let columnsSort = {};
            Object.keys(this.detailTables).forEach((name) => {
                Object.keys(this.detailTables[name].columns).forEach((column) => {
                    if (column === '1_month')
                        columnsSort[name] = {
                            ...columnsSort[name],
                            [column]: {typeColumn: 'Month'}
                        };
                    else
                        columnsSort[name] = {
                            ...columnsSort[name],
                            [column]: {typeColumn: 'Number'}
                        };
                });
            });
            return columnsSort;
        },
    },
    mounted() {
        this.postBudget();
        this.getDataSummary();
    },
    methods: {
        clearSelected(){
            this.selectedDetailSummary = '';
        },
        showDetail(attribute){
            if(Object.keys(this.detailTables).length === 0){
                this.getDataSummaryDetail();
            }
            this.selectedDetailSummary = attribute;
        },
        /**
         * получить данные для таблицы текущего бюджета
         * @async
         */
        async postBudget() {
            this.isTableDates = true;
            try {
                let {data = {}} = await serviceApi.post(routeAnalyticsTotalBudget, this.reqBodyGetDataClients);
                let {data: tableDates  = {}} = data;

                // this.setFilterData(filter);
                let tableDatesColected = this.collectTableDates(tableDates);
                this.tableDates = {
                    ...tableDatesColected, 
                    title: 'Текущий бюджет'
                };
            }
            catch(error) {
                if (error.message === 'not server')
                    alert('Извините, сервер временно недоступен');
            }
            this.isTableDates = false;
        },
        /**
         * сделать запрос на получения данных
         * @async
         */
        async getDataSummary() {
            this.isPreloader = true;
            try {
                let {data = {}} = await serviceApi.post(routeAnalyticsSummary, this.reqBodyGetDataClients);
                let {filter = {}, analytics = {}} = data;
                this.setFilterData(filter);
                this.tableSummary = analytics;
            }
            catch(error) {
                if (error.message === 'not server')
                    alert('Извините, сервер временно недоступен');
            }
            this.isPreloader = false;
        },
        /**
         * сделать запрос на получение детализации
         * @async
         */
        async getDataSummaryDetail() {
            this.isPreloader = true;
            try {
                let {data = {}} = await serviceApi.post(routeAnalyticsSummaryDetail, this.reqBodyGetDataClients);
                let {analytics = {}} = data;
                let {col_labels: colLabels = {}, months = {}, tables = {}} = analytics;
                Object.keys(this.tableNames).forEach((tableKey) => {
                    this.detailTables = {
                        ...this.detailTables,
                        [tableKey]: this.collectTableData(tableKey, colLabels, months, tables[tableKey])
                    };
                });
            }
            catch(error) {
                if (error.message === 'not server')
                    alert('Извините, сервер временно недоступен');
            }
            this.isPreloader = false;
        },
        /**
         * событие изменения фильтра
         * @param {object} newFilterData - новые данные фильтра
         */
        onChangeFilter(newFilterData) {
            this.setFilterSelected(newFilterData);
            this.filterDataSelected = newFilterData;
            this.postBudget();
            this.getDataSummary();
            if(this.selectedDetailSummary !== ''){
                this.getDataSummaryDetail();
            }else {
                this.detailTables = {};
            }
        },
        /**
         * собрать данные для таблицы текущего бюджета
         * @param {Object} tableDates - данные таблицы текущего бюджета
         * @returns {Object}
         */
        collectTableDates(tableDates = {}) {
            let {cols = {}, header = {}, labels = {}} = tableDates;
            let rowsCollected = [];
            Object.entries(labels).forEach(([labelKey, labelValue]) => {
                let rowItem = {
                    '0-total': String(labelValue).replace('итого', ''),
                    '0-totalValue': cols.total[labelKey]
                };
                Object.keys(cols).forEach((colKey) => {
                    if (colKey !== 'total')
                        rowItem[colKey] = cols[colKey][labelKey];
                });
                rowsCollected.push(rowItem);
            });
            let tableDataCollected = {
                labels: new Map(Object.entries({
                    '0-total': 'Бюджет',
                    '0-totalValue': 'Итого',
                    ...header
                })),
                rows: rowsCollected
            };
            return tableDataCollected;
        },
        /**
         * собрать данные таблиц
         * @param {string} tableKey - ключ таблицы
         * @param {object} colLabels - названия колонок
         * @param {object} months - месяца
         * @param {object} table - данные таблицы
         */
        collectTableData(tableKey, colLabels, months, table) {
            let columns = {
                '1_month': 'месяц',
                ...colLabels
            };
            let rows = [];
            for (let [monthsKey, monthsValue] of Object.entries(months)) {
                let row = {
                    '1_month': monthsValue,
                };
                Object.keys(colLabels).forEach((colKey) => {
                    row[colKey] = table[colKey][monthsKey];
                });
                rows.push(row);
            }

            let tableDataCollected = {
                columns: columns,
                rows: rows
            };
            return tableDataCollected
        },
    }
}
</script>

<style lang="scss" scoped>
    .content {
        width: 100%;
        margin-bottom: 10px;
    }
    .budget {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        flex-wrap: wrap;
    }

    .budget__item {
        background: #fff;
        border-radius: 15px;
        padding: 30px;
        width: 19.4%;
        min-width: 260px;
        margin: 0 0 10px 0;

        box-sizing: border-box;
    }

    .budget__count {
        font-size: 2em;
    }

    .budget-dynamic {
        margin: 10px 0 20px 0;
        color: #b0b1b4;
    }

    .budget-dynamic__item {
        position: relative;
        padding-left: 34px;
        margin-top: 10px;
        padding-bottom: 10px;
        border-bottom: 1px solid #e8ebef;
    }

    .budget-dynamic__date {
        font-size: 0.75em;
    }

    .budget-dynamic__date span {
        margin: 0 7px;
    }

    .budget-dynamic__count {
        font-size: 1.4em;
        color: #000
    }

    .budget-dynamic__arrow {
        position: absolute;
        background: #e8ebef;
        width: 24px;
        height: 24px;
        top: 0;
        left: 0;
        border-radius: 4px;
        text-align: center;
        line-height: 24px;
        color: #000;
        font-size: 1em;
    }

    .budget-dynamic__arrow_max {
        background: #C6EFC9;
        color: #30C538;
    }

    .budget-dynamic__arrow_min {
        background: #FBD1DF;
        color: #fe1060
    }

    .simple-link{
        outline: none;
        background: transparent;
        border: 0;
        color: blue;
        text-decoration: underline;
        cursor: pointer;
    }
    .view-analytics-budget__table-title {
        font-size: 20px;
        margin-bottom: 20px;
    }
</style>